var $b60c7d6ecb26fe35$exports = {};
"use strict";
//Hämta element från HTML
const $b60c7d6ecb26fe35$var$hamburgerEl = document.querySelector(".hamburger");
const $b60c7d6ecb26fe35$var$navMenuEl = document.querySelector(".nav-menu");
const $b60c7d6ecb26fe35$var$navMobile = document.querySelector(".nav-mobil");
//Eventlistener för toggla menyn
$b60c7d6ecb26fe35$var$hamburgerEl.addEventListener("click", $b60c7d6ecb26fe35$var$toggleMenu);
//Aktivera klass för hamburgermenyn
function $b60c7d6ecb26fe35$var$toggleMenu() {
    $b60c7d6ecb26fe35$var$hamburgerEl.classList.toggle("active");
    $b60c7d6ecb26fe35$var$navMenuEl.classList.toggle("active");
    $b60c7d6ecb26fe35$var$navMobile.classList.toggle("active");
    // Toggle meny text
    const menuTextEl = document.querySelector(".menu-text");
    if (menuTextEl.innerHTML === "Meny") menuTextEl.innerHTML = "St\xe4ng";
    else menuTextEl.innerHTML = "Meny";
    //Kalla på funktion för klick på länk
    $b60c7d6ecb26fe35$var$closeDropDown();
}
//vid klick på länk ska dropdown meny stängas
function $b60c7d6ecb26fe35$var$closeDropDown() {
    const linksEl = document.querySelectorAll(".nav-link");
    linksEl.forEach((link)=>{
        link.addEventListener("click", $b60c7d6ecb26fe35$var$toggleMenu);
    });
}


//# sourceMappingURL=index.f4d695f3.js.map
